import { Breathe, BREATHE_DEFAULT_SPEED } from '../Breathe/Breathe';
import { Rise, RISE_DEFAULT_SPEED } from '../Rise/Rise';
import { Wipe, WIPE_DEFAULT_SPEED } from '../Wipe/Wipe';
import { Fade, FADE_DEFAULT_SPEED } from '../Fade/Fade';
import { Pan, PAN_DEFAULT_SPEED } from '../Pan/Pan';
import { PageAnimationTypes } from '../types';

export const isPartiallyInViewport = (
  ref: React.MutableRefObject<HTMLElement | null>,
  topOffset?: number
) => {
  if (ref.current) {
    const element = ref.current;
    const rect = element.getBoundingClientRect();
    const offset = topOffset || 0;
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.top <= (window.innerHeight || document.documentElement.clientHeight) - offset &&
      rect.left <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  return false;
};

export const getPageAnimationComponent = (animationName: PageAnimationTypes | undefined) => {
  switch (animationName) {
    case 'page-animation-breathe':
      return Breathe;
    case 'page-animation-rise':
      return Rise;
    case 'page-animation-wipe':
      return Wipe;
    case 'page-animation-fade':
      return Fade;
    case 'page-animation-pan':
      return Pan;
    default:
      return null;
  }
};

export const getDefaultSpeedForPageAnimation = (animationName: PageAnimationTypes | undefined) => {
  switch (animationName) {
    case 'page-animation-breathe':
      return BREATHE_DEFAULT_SPEED;
    case 'page-animation-rise':
      return RISE_DEFAULT_SPEED;
    case 'page-animation-wipe':
      return WIPE_DEFAULT_SPEED;
    case 'page-animation-fade':
      return FADE_DEFAULT_SPEED;
    case 'page-animation-pan':
      return PAN_DEFAULT_SPEED;
    default:
      return 1;
  }
};
